import gql from 'graphql-tag'
import Vue from 'vue'
const axios = require('axios')

export default {
  data() {
    return {
      error: '',
      errs: {
        applicationInformation: {},
        employmentInformation: {},
        personalInformation: {},
        accountInformation: {},
        microDepositInformation: {}
      },
      loading: false,
      nextClicked: false,
      step: '',

      email: '',
      employer: '',
      code: '',
      verifying: false,
      // validSubEmployer: false,

      applicationInformation: {},
      employmentInformation: {},
      personalInformation: {},
      accountInformation: {},
      microDepositInformation: {},
      qualifies: {},
      terms: {
        experian: false,
        plaid: false,
        viva: false,
        dwolla: false,
        employerRelease: false
      }
    }
  },
  computed: {
    alias() {
      return this.email.match(/^\d{10}$/)
        ? `+1${this.$setters.phone_number(this.email).slice(-10)}`
        : `${this.email.trim().toLowerCase()}${
            this.employer && !this.email.includes('@')
              ? `@${this.$store.getters.employerDomain}`
              : ''
          }`
    },
    disabled() {
      switch (this.step) {
        case 'creates':
          if (this.$store.getters.verifying) {
            return !this.code.match(/^\d{6}$/)
          } else {
            return !(
              (this.email && this.terms.viva && this.terms.employerRelease && this.terms.dwolla)
              // this.validSubEmployer
            )
          }
        case 'details':
          return !this.validate('applicationInformation') || !!this.error
        case 'identifies':
          if (this.verifying) {
            return !this.code.match(/^\d{6}$/)
          } else {
            return !this.validate('personalInformation')
          }
        case 'informs':
          return !this.validate('employmentInformation') || !!this.error
        case 'qualifies':
          return !!this.error
        case 'links':
          if (this.$store.state.exited) {
            return !this.validate('accountInformation') || !this.selectedAccount
          } else {
            return !(this.terms.experian && this.terms.plaid)
          }
        case 'verifies':
          return !this.validate('microDepositInformation')
        case 'uploads':
          return this.files.filter(({ url }) => url).length !== 2
        default:
          return false
      }
    }
  },
  watch: {
    error() {
      this.loading = false
      this.nextClicked = false
    },
    step(s, old) {
      window.scrollTo({ top: 0, behavior: 'smooth' })

      this.error = ''
      this.loading = false
      this.nextClicked = false
    },
    verifying() {
      // window.scrollTo({ top: 0, behavior: 'smooth' });

      this.code = ''
      this.error = ''
      this.loading = false
      this.nextClicked = false
    },
    '$store.getters.verifying': function () {
      this.code = ''
      this.error = ''
      this.loading = false
      this.nextClicked = false
    }
  },
  methods: {
    back() {
      if (this.verifying) {
        this.verifying = false
      } else {
        this.step = this.steps[this.steps.indexOf(this.step) - 1]
      }
    },
    calculateAge(birthday) {
      const ageDifMs = Date.now() - birthday.getTime()
      const ageDate = new Date(ageDifMs)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
    load(s) {
      this[s] = Object.entries(
        s === 'personalInformation'
          ? this.$store.getters.personalInformation
          : s === 'employmentInformation'
          ? this.$store.state.employmentInformation
          : this.$store.state.applicationInformation
      ).reduce(
        (result, [k, v]) =>
          Object.assign(result, {
            [k.replace('custom:', '')]: this.$setters[k.replace('custom:', '')]
              ? this.$setters[k.replace('custom:', '')](`${v}`)
              : v
          }),
        {}
      )
      try {
        ;[this[s].address, this[s].unit] = this[s].address.split(' | ')
      } catch (e) {}
      try {
        this[s].phone_number = this[s].phone_number.slice(1)
        // this[s].ssn = this[s].ssn.replace(/^.{5}/g, '*****');
      } catch (e) {}
      try {
        this[s].home_phone_number = this[s].home_phone_number.slice(1)
        // this[s].ssn = this[s].ssn.replace(/^.{5}/g, '*****');
      } catch (e) {}
      try {
        const year = this[s].birthdate.slice(0, 4)
        const month = this[s].birthdate.slice(4, 6)
        const day = this[s].birthdate.slice(6)
        this[s].birthdate = `${month}${day}${year}`
      } catch (e) {}
      try {
        const year = this[s].start.slice(0, 4)
        const month = this[s].start.slice(4, 6)
        const day = this[s].start.slice(6)
        this[s].start = `${month}${year}`
      } catch (e) {}
    },
    set(s, inputs) {
      const state = Object.entries(this[s])
        .filter(([k, v]) => v && this[inputs].map((i) => i.key).includes(k))
        .reduce(
          (result, [k, v]) =>
            Object.assign(result, { [k]: this.$getters[k] ? this.$getters[k](v) : v }),
          {}
        )
      if (state.birthdate) {
        state.birthdate = new Date(Date.parse(state.birthdate)).toISOString().split('T')[0]
      }
      if (state.phone_number) {
        state.phone_number = `+1${this.$setters.phone_number(state.phone_number)}`
      }
      if (state.home_phone_number) {
        state.home_phone_number = `+1${this.$setters.home_phone_number(state.home_phone_number)}`
      }
      if (state.additional) {
        state.additional = parseInt(state.additional.replace(/,/g, ''), 10)
      }
      if (state.amount) {
        state.amount = parseInt(state.amount.replace(/,/g, ''), 10)
      }
      if (state.salary) {
        state.salary = parseInt(state.salary.replace(/,/g, ''), 10)
      }
      if (state.start) {
        state.start = `${state.start.split('/')[0]}/01/${state.start.split('/')[1]}`
        state.start = new Date(Date.parse(state.start)).toISOString().split('T')[0]
      }
      if (state.unit) {
        state.address = `${state.address} | ${state.unit}`
        delete state.unit
      }
      return this.$store.dispatch(`update${s.charAt(0).toUpperCase()}${s.slice(1)}`, state)
    },
    properNoun(s) {
      const words = s.trim().split(' ')
      const nonCapWords = ['a', 'an', 'the', 'to', 'of', 'and']
      const capWords = words.map((w) => {
        w = w.toLowerCase()
        return nonCapWords.includes(w) ? w : w[0].toUpperCase() + w.slice(1)
      })
      return capWords.join(' ')
    },
    stateAbbrToName(abbr) {
      const abbrNameDict = {
        AL: 'Alabama',
        AK: 'Alaska',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming'
      }
      return abbrNameDict[abbr.toUpperCase()]
    },
    next() {
      if (this.disabled) {
        this.nextClicked = true
        setTimeout(() => {
          this.nextClicked = false
        }, 250)
        return
      }

      this.error = ''
      this.loading = true
      this.nextClicked = true
      switch (this.step) {
        case 'creates':
          // waiting for code to be entered
          if (this.$store.getters.verifying) {
            this.$authenticate(this.code)
              .then(() => {
                this.$Auth
                  .currentSession()
                  .then(() => {
                    if (
                      (this.$route.path.toLowerCase().includes('register') ||
                        this.$route.path.toLowerCase().includes('accessdevelopment') ||
                        this.$route.path.toLowerCase().includes('youdecide') ||
                        this.$route.path.toLowerCase().includes('myeducationdiscount') ||
                        this.$route.path.toLowerCase().includes('perkspot') ||
                        this.$route.path.toLowerCase().includes('perks') ||
                        this.$route.path.toLowerCase().includes('perksatwork') ||
                        this.$route.path.toLowerCase().includes('lifemart') ||
                        this.$route.path.toLowerCase().includes('freeway') ||
                        this.$route.path.toLowerCase().includes('benefithub') ||
                        this.$route.path.toLowerCase().includes('corestream') ||
                        this.$route.path.toLowerCase().includes('leads')) &&
                      this.$gtm.enabled() &&
                      window.dataLayer
                    ) {
                      window.dataLayer.push({
                        event: 'successfulAccountCreation',
                        stage: this.$store.getters.isProduction ? 'production' : 'dev',
                        email: this.email,
                        username: this.$store.getters.username
                      })
                      if (this.$route.query && this.$route.query.originId) {
                        const originId = this.$route.query.originId
                        this.$store.dispatch('applicationData/logOriginTracking', originId)
                      }
                      if (this.$store.getters.applyNowRoute.length === 0) {
                        this.$store.commit('applicationData/setApplyNowRoute', window.location.href)
                      }
                      this.$store.dispatch('applicationData/justRegistered')
                    }
                  })
                  .catch(() => {
                    this.code = ''
                    this.error = 'Incorrect security code'
                    console.log(`FE Error in uploadFilesAxios: ${this.error}`)
                  })
              })
              .catch((e) => {
                this.error = e
                const userName = this.$store.getters.username
                console.log(
                  `[REG TRACKING error for user ${userName} with email ${this.email}] frontend likely contains a registration bug: ${e}`
                )
                // if (e.toLowerCase().includes('frontend likely contains a registration bug')) {
                //   this.error =
                //     'We are having technical difficulties at the moment. Pleae give us a call.'
                // }
              })
          } else {
            if (this.$route.path.includes('login')) {
              this.$signIn(this.alias)
                .then(() => {
                  if (this.$gtm.enabled() && window.dataLayer) {
                    window.dataLayer.push({
                      event: 'logIn',
                      stage: this.$store.getters.isProduction ? 'production' : 'dev',
                      username: this.$store.getters.username,
                      firstName: this.$store.getters.firstName,
                      lastName: this.$store.getters.lastName,
                      phoneNumber: this.$store.getters.phoneNumber,
                      addrCountry: this.$store.getters.addrCountry,
                      addrPostalCode: this.$store.getters.addrPostalCode
                    })
                  }
                })
                .catch((e) => {
                  this.error = e
                })
            } else {
              this.$signUp(this.alias).catch((e) => {
                this.error = e
              })
            }
          }
          break
        case 'details':
          try {
            this.set('applicationInformation', 'aI')
              .then(() => {
                this.step = 'identifies'
              })
              .catch((e) => {
                this.error = e
              })
          } catch (e) {
            this.error = e
          }

          break
        case 'identifies':
          if (this.verifying) {
            this.$Auth
              .verifyCurrentUserAttributeSubmit('phone_number', this.code)
              .then(() => this.$Auth.currentAuthenticatedUser({ bypassCache: true }))
              .then((user) => {
                this.$store.commit('updateUser', user)
                this.$store.commit('applicationData/updateUser', user)
                this.load('personalInformation')
                this.verifying = false
                this.step = 'informs'
              })
              .catch((e) => {
                this.code = ''
                // this.error = e
              })
          } else {
            try {
              this.set('personalInformation', 'pI')
                .then(() => {
                  if (this.$store.getters.personalInformation.phone_number_verified) {
                    this.verifying = false
                    this.step = 'informs'
                  } else {
                    this.$Auth
                      // sends the text
                      .verifyCurrentUserAttribute('phone_number')
                      .then(() => {
                        this.verifying = true
                      })
                      .catch((e) => {
                        console.log(e)
                        this.error = e
                      })
                  }
                })
                .catch((e) => {
                  this.error = e
                })
            } catch (e) {
              this.error = e
            }
          }

          break
        case 'informs':
          try {
            this.set('employmentInformation', 'eI')
              .then(() => this.$store.dispatch('updateQualifies'))
              .then((data) => {
                this.step = 'qualifies'
              })
              .catch((e) => {
                this.$router.push({ name: '_Restricted' })
                // this.error = e;
              })
          } catch (e) {
            this.error = e
          }

          break
        case 'qualifies':
          this.step = 'links'
          break
        case 'links':
          if (this.$store.state.exited) {
            //ToDo: change name to manually
            this.$store
              .dispatch('initializes', {
                account: this.accountInformation.account_number,
                name: this.accountInformation.institution_name,
                routing: this.accountInformation.routing_number,
                type: this.selectedAccount
              })
              .then((data) => {
                this.step = 'verifies'
              })
              //ToDo: may trip me up, need to test
              .catch((e) => {
                if (
                  e.message.includes('Micro deposits already initiated for this funding source')
                ) {
                  this.step = 'verifies'
                } else {
                  this.error = e
                }
              })
          } else {
            this.$store
              .dispatch('links')
              .then(() => {
                this.loading = false
              })
              .catch((e) => {
                this.error = e
                this.loading = false
              })
          }

          break
        case 'verifies':
          // this.$store.dispatch('accounts').then(() => {
          this.$store
            .dispatch('verifies', {
              amount1: this.microDepositInformation.deposit_one,
              amount2: this.microDepositInformation.deposit_two
            })
            // })
            .then(() => {
              this.$store.state.accounts[0].verified = true
              this.step = 'uploads'
            })
            .catch((e) => {
              console.log(e)
              this.error = e

              // this.loading = false;
            })

          break
        case 'uploads':
          Promise.all(
            this.files.map(({ file, url }) =>
              axios.put(url, file, {
                headers: {
                  'Content-Type': file.type
                }
              })
            )
          )
            .then(() => {
              const prodSlackMentions = Vue.prototype.$production
                ? '<@UQY88UB4Z> and <@UK12J9C3F> '
                : ''
              Vue.prototype.$apiClient.mutate({
                mutation: gql(`mutation {
                  logs(message: "${encodeURI(`${prodSlackMentions}Paystubs uploaded.`)}")
                }`)
              })
              setTimeout(() => {
                this.$store
                  .dispatch('statements')
                  .then(() => {
                    this.$router.push({ name: '_Restricted' })
                  })
                  .catch((e) => {
                    this.error = e
                  })
              }, 250)
            })
            .catch((e) => {
              this.error = e
            })

          break
      }
      // this.loading = false;
    }
  }
}
